import React from "react"

function IconFunnel({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="funnel"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-funnel"
      {...props}
    >
      <path
        d="m21.972 4.8-6.61 9.614-.571 5.71-4.465 1.488-.601-7.204L3.119 4.8h18.853zm-7.97 10.036h-2.928l.418 5.007 2.08-.694.43-4.313zm5.48-8.727H5.608l5.1 7.418h3.676l5.1-7.418z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFunnel
